module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md9": "",
      "offset-md2": "",
      "mb-2": ""
    }
  }, [_c('v-card', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    attrs: {
      "inset": ""
    }
  }, [_vm._v("Join requests")]), _vm._v(" "), _vm._l((_vm.notifications), function(item) {
    return _c('v-list-tile', {
      key: item.uid,
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": item.avatar
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.firstname + ' ' + item.lastname))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.jobtitle + ' at ' + item.companylegalname))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-layout', [_c('v-flex', {
      attrs: {
        "md6": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "color": "green",
        "ripple": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.accept(item)
        }
      }
    }, [_vm._v("\n                        ACCEPT\n                      ")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md6": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "color": "red",
        "ripple": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.deny(item)
        }
      }
    }, [_vm._v("\n                        DENY\n                      ")])], 1)], 1)], 1)], 1)
  })], 2)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7abd78bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/grouppage/notifications.vue
// module id = 1703
// module chunks = 17